import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BookingStatusLayer from "../components/BookingStatusLayer";

const BookingStatusPage = () => {
    return (
        <MasterLayout>
            <BookingStatusLayer />
        </MasterLayout>
    );
};

export default BookingStatusPage;
